import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-enroll-add-user',
  templateUrl: './enroll-add-user.component.html',
  styleUrls: ['./enroll-add-user.component.scss']
})
export class EnrollAddUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
